import {makeAutoObservable, runInAction} from "mobx";
import type {Subscription} from "rxjs";
import {catchError, forkJoin, from, map, throwError} from "rxjs";
import type {MithraMaterializedApi} from "../services/MithraMaterializedApi";
import type ProfileStore from "./ProfileStore";
import type {TaxonomyCategoryData} from "../services/classes/AiClasses";

export type TaxonomyCategory = {
    // values: string[]
    label: string
    search: string
    data: TaxonomyCategoryData
}

export class TaxonomyCategoryProvider {
    taxonomy_categories: TaxonomyCategory[] | undefined | null;

    private retrieveSubscription?: Subscription

    constructor(private profileStore: ProfileStore, private api: MithraMaterializedApi) {
        makeAutoObservable(this)
    }

    fillCategoriesFromTaxonomy(taxonomyId: number) {
        if (this.retrieveSubscription) {
            this.retrieveSubscription.unsubscribe()
        }

        this.taxonomy_categories = undefined

        this.retrieveSubscription = forkJoin([
            from(this.api.getTaxonomyCategoriesV2(taxonomyId)).pipe(
                map(taxonomyResult => {
                    const categories = taxonomyResult.data.base_categories;
                    if (!categories) {
                        return [];
                    }
                    return categories.map<TaxonomyCategory>(categoryData => ({
                        label: categoryData.labels.join(', '),
                        // values: categoryData.labels,
                        search: Array.from(new Set(
                            categoryData.labels
                                .flatMap(l => l.split('-'))
                                .concat([categoryData.category_id ? categoryData.category_id : ''])
                        ))
                            .filter(s => s)
                            .join(' '),
                        data: categoryData,
                    }));
                }),
                catchError(err => {
                    // More specifically, we probably did not set a correct taxonomy for this bag yet
                    runInAction(() => this.taxonomy_categories = null);
                    return throwError(err);
                })
            ),
        ]).subscribe({
            next: ([taxonomy]) => {
                runInAction(() => {
                    this.taxonomy_categories = taxonomy
                });
            },
            error: err => {
                console.error('Cannot load taxonomy categories', err)
            },
        })
    }

    arrest(error?: string) {
        error = error ?? 'Unknown error'
        console.error(error)
        if (this.retrieveSubscription) this.retrieveSubscription.unsubscribe()
        this.taxonomy_categories = undefined
    }

}
